import {createSlice} from '@reduxjs/toolkit';
import {setSpinner} from '../spinner/spinnerSlice';
import API from '../../common/api';
import {createUsers, updateDevices} from '../../app/models/UsersModel';
import {refreshLocations} from '../../app/models/LocationsModel';
import {createCircles} from '../../app/models/CirclesModel';
import {createPendingUser} from '../../app/models/PendingUsersModel';

const FORCE_DATA_REFRESH_DELAY = 5000; //5 sec


export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        activeCircle: null,
        activeUser: null,
        browserCoords: {},
        showDownloadNote: true,
        showDownloadModal: false
    },
    reducers: {
        setActiveCircle: (state, action) => {
            state.activeCircle = action.payload;
        },
        setDownloadNote: (state, action) => {
            state.showDownloadNote = action.payload;
        },
        setActiveUser: (state, action) => {
            state.activeUser = action.payload;
        },
        setBrowserCoords: (state, action) => {
            state.browserCoords = action.payload;
        },
        setShowDownloadModal: (state, action) => {
            state.showDownloadModal = action.payload;
        },
        clearDashboardData: (state, action) => {
            state.activeCircle = null;
            state.activeUser = null;
        }
    },
});

export const {setActiveCircle, setShowDownloadModal, setActiveUser, setBrowserCoords, clearDashboardData, setDownloadNote} = dashboardSlice.actions;

export const updateData = (token, showLoader) => async dispatch => {
    showLoader && dispatch(setSpinner(true));

    try {
        const userGeoInfo = await API.setAllUsersGeoInfo(token);
        const circlesInfo = await API.getCirclesInfo(token);
        const invitesInfo = await API.getAllInvites(token);
        const devicesInfo = await API.getDevicesInfo(token);

        dispatch(createUsers({userData: circlesInfo, devicesData: devicesInfo}));
        dispatch(updateDevices(devicesInfo));
        dispatch(createCircles(circlesInfo));
        dispatch(refreshLocations(userGeoInfo));
        dispatch(createPendingUser(invitesInfo));

    } catch (e) {
        return e;
    }
    finally {
        showLoader && dispatch(setSpinner(false));
    }
};

export const updateBELocationsOnly = (token, spinner) => async dispatch => {
    try {
        const userGeoInfo = await API.setAllUsersGeoInfo(token);
        dispatch(refreshLocations(userGeoInfo));

    } catch (e) {
        return e;
    } finally {
        spinner(false);
    }
}

export const updateDataInBackground = (token, saveTimeoutID) => async dispatch => {
    let isInviteAccepted = false;

    try {

        const userGeoInfo = await API.setAllUsersGeoInfo(token);
        const circlesInfo = await API.getCirclesInfo(token);

        dispatch(createUsers(circlesInfo));
        dispatch(createCircles(circlesInfo));
        dispatch(refreshLocations(userGeoInfo));


        if (userGeoInfo.length > 1) {
            isInviteAccepted = true;
        }


    } catch (e) {
        return e;
    } finally {
        const timeout = setTimeout(() => token && updateDataInBackground(token, saveTimeoutID)(dispatch), FORCE_DATA_REFRESH_DELAY);
        saveTimeoutID(timeout);

        if (isInviteAccepted) {
            window.clearTimeout(timeout);
        }
    }
};


export const selectActiveCircle = state => state.dashboard.activeCircle;
export const selectActiveUser = state => state.dashboard.activeUser;
export const selectBrowserCoords = state => state.dashboard.browserCoords;
export const selectShowDownload = state => state.dashboard.showDownloadNote;
export const selectShowDownloadModal = state => state.dashboard.showDownloadModal;

export default dashboardSlice.reducer;

